const { baseUrl, instance } = require('./url')

/**
 * The % was not converting right when just called
 *      encodeURIComponent
 * @param {string} str
 * @return {string}
 */
function removeNonUrl(str) {
    return str
        .replaceAll('%', '')
}

function getUrl(quote, didSave) {

    // for (let i = 0; i < quote.signs.length; i++) {
    //     quote.signs[i].square_inch_price =
    //         quote.signs[i].sqrInchPrice()
    //     quote.signs[i].unit_price =
    //         quote.signs[i].unitPrice()
    //     quote.signs[i].total_price =
    //         quote.signs[i].totalPrice()
    // }

    let pdfName = quote.job_name
    if (pdfName.length === 0) {
        pdfName = 'PDF'
    }

    // const quoteStr = encodeURIComponent(JSON.stringify(quote))

    let url = ''
    // let url = baseUrl + '/pdf/quote/' +
    //     encodeURIComponent(removeNonUrl(quote.job_name + '-' + quote.given_id)) +
    //     '.pdf?quote=' + quoteStr
    // if (url.length >= 2000) {
        url = baseUrl + '/pdf/id/' +
            encodeURIComponent(removeNonUrl(quote.job_name + '-' + quote.given_id)) +
            '.pdf?id=' + quote.id

        if (!didSave) {
            return null
        }
    // }

    return url
}

function downloadPDF(quote, didSave, newTab=false) {

    const url = getUrl(quote, didSave)
    if (url === null) {
        return true
    }

    if (newTab===true) {
        window.open(url, '_blank')
    } else {
        window.location.href = url
    }

    return false
}


// MARK: Package Slip

function getUrlPackageSlip(quote, quantities=[], packagingNumber='00001', notes='') {
    let url = ''
        url = baseUrl + '/pdf/packagingslip/id/' +
            encodeURIComponent(removeNonUrl(quote.job_name + '-' + quote.given_id)) +
            '.pdf?id=' + quote.id +
            '&quantities=[' + quantities.join(',') + ']' +
            '&packagingNumber=' + packagingNumber +
            '&notes=' + notes

    return url
}

function downloadPackageSlip(quote, quantities=[], packagingNumber='00001', notes='') {
    const url = getUrlPackageSlip(quote, quantities, packagingNumber, notes)
    window.open(url, '_blank')
}

async function downloadProjectManagerPDF(sections, projectManager) {
    for (let key in sections) {
        sections[key] = sections[key].map((quote) => {
            return ((
                { id, customer_name, job_name, project_manager_comment}
            ) => (
                { id, customer_name, job_name, project_manager_comment }
            ))(quote)
        })
    }
    return await instance.post(
        '/pdf/projectmanager/',
        {
            'sections': sections,
            'project_manager': projectManager,
        },
    ).then(
        (result) => {
            const id = result.data.id
            window.open(baseUrl + '/file/onetimeuse/' + id + '/ProjectManager.pdf', '_blank')
            return id
        }
    )
}

async function downloadPurchaseOrderWithId(
    id
) {
    return await instance.post(
        '/pdf/purchase_order/' + id,
    ).then(
        (result) => {
            const id = result.data.id
            window.open(baseUrl + '/file/onetimeuse/' + id + '/PurchaseOrder.pdf', '_blank')
            return id
        }
    )
}

async function downloadPurchaseOrder(
    companyName, company_address,
    orderDate, shipVia, orderBy, deliveryDate, items,
    salesTax, shippingCharge, discount,
    notes,
) {
    return await instance.post(
        '/pdf/purchase_order/',
        {
            'company_name': companyName,
            'company_address': company_address,
            'order_date': orderDate,
            'ship_via': shipVia,
            'order_by': orderBy,
            'delivery_date': deliveryDate,
            'items': items,
            'sales_tax': salesTax,
            'shipping_charge': shippingCharge,
            'discount': discount,
            'notes': notes,
        },
    ).then(
        (result) => {
            const id = result.data.id
            window.open(baseUrl + '/file/onetimeuse/' + id + '/PurchaseOrder.pdf', '_blank')
            return id
        }
    )
}

function downloadInvoicePDF(quoteId, jobName, newTab=false) {

    const url = '/api/pdf/invoice/' + quoteId + '/' + jobName + '-invoice.pdf'

    if (newTab===true) {
        window.open(url, '_blank')
    } else {
        window.location.href = url
    }

    return false
}

function downloadOpenInvoicePDF(customerName=null, newTab=false) {
    const url = '/api/pdf/open_invoices/invoice.pdf'

    if (newTab===true) {
        window.open(url, '_blank')
    } else {
        window.location.href = url
    }

    return false
}

// Unlike the other generate-then-download helpers above, this doesn't
// window.open a one-time-use download - the generated PDF is saved as a
// normal, persistent, overwrite-on-regenerate file (see replaceDrawingImage/
// DRAWING_DATA_PDF.md), already reachable via the existing "Download
// Generated PDF" link on the Drawing Data page once this resolves.
async function generateDrawingDataPdf(quoteId) {
    return await instance.post('/pdf/drawingdata/' + quoteId)
}

export {
    downloadPDF,
    getUrl,
    downloadPackageSlip,
    downloadProjectManagerPDF,
    downloadPurchaseOrder,
    downloadPurchaseOrderWithId,
    downloadInvoicePDF,
    downloadOpenInvoicePDF,
    generateDrawingDataPdf,
}

